import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from 'components/Button/Button';
import TagSelect from 'components/EditableTags/TagSelect';
import ColorPicker from 'components/form/ColorPicker';
import TextInput from 'components/form/TextInput';
import useTags from 'hooks/useTags';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import LogoVideoOption from '../LogoVideoOption';

const BasicDetails = ({
  data,
  onInputChange,
  onRadioChange,
  onStepChange,
  onTagsChange,
}) => {
  const {
    card_headline,
    card_description,
    logo_or_video_url,
    logo_or_video,
    card_template,
    card_background_color,
    card_text_color,
    tags = [],
  } = data;
  const [t] = useTranslation('connectCard');
  const { tags: availableTags } = useTags('connect_card');

  return (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography>{t('primary-card-color', 'Primary Card Color')}</Typography>
        <ColorPicker
          value={card_background_color}
          onChange={(val) =>
            onInputChange({
              target: { name: 'card_background_color', value: val },
            })
          }
          size="small"
        />
      </Stack>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Typography>{t('cc-font-color', 'Font Color')}</Typography>
        <ColorPicker
          value={card_text_color}
          onChange={(val) =>
            onInputChange({
              target: { name: 'card_text_color', value: val },
            })
          }
          size="small"
        />
      </Stack>
      <Box mb={3}>
        <LogoVideoOption
          onInputChange={onInputChange}
          logo_or_video_url={logo_or_video_url}
          logo_or_video={logo_or_video}
        />
        <Box mt={4}>
          <Typography paragraph fontWeight={500}>
            {t('edit-card-info-section-title', 'Edit Headline and Description')}
          </Typography>
          <TextInput
            fullWidth
            margin="none"
            name="card_headline"
            value={card_headline}
            onChange={onInputChange}
            label={t('card-headline', 'Headline')}
            placeholder={t(
              'card-headline-placeholder',
              'Thanks for connecting with us!',
            )}
          />
          <TextInput
            fullWidth
            multiline
            minRows={3}
            name="card_description"
            value={card_description}
            onChange={onInputChange}
            label={t('card-description', 'Description')}
            placeholder={t(
              'card-description-placeholder',
              'Tell us a little about yourself',
            )}
          />
          <Box mt={2}>
            <TagSelect
              value={tags}
              label="Tags (Optional)"
              placeholder="Select or create tags..."
              availableTags={availableTags}
              onChange={onTagsChange}
            />
          </Box>
        </Box>
      </Box>
      <Button fullWidth onClick={() => onStepChange('questions')}>
        {t('common:next', 'Next')}
      </Button>
    </Box>
  );
};

export default BasicDetails;
